import CardsBlock from './Cards';

export default CardsBlock;
